import React, { createContext, useContext, useMemo } from "react";

/** Full P2P access flags for isolated Super Admin sessions. */
export const SUPER_ADMIN_P2P_CONTEXT = {
  is_super_admin: true,
  is_platform_admin: true,
  is_company_admin: true,
  has_p2p_org_membership: true,
  can_approve: true,
  can_access_command_centre: true,
  can_submit_service_requests: true,
  can_access_preapproved_vendors: true,
  can_access_sales_auction_controls: true,
  is_platform_team_console_admin: true,
  is_platform_team: true,
  is_account_manager_only: false,
  platform_team_role: "head",
};

const SuperAdminP2PNavigationContext = createContext({
  loading: false,
  ctx: SUPER_ADMIN_P2P_CONTEXT,
  reload: async () => {},
});

export function SuperAdminP2PNavigationProvider({ children }) {
  const value = useMemo(
    () => ({
      loading: false,
      ctx: SUPER_ADMIN_P2P_CONTEXT,
      reload: async () => {},
    }),
    [],
  );

  return (
    <SuperAdminP2PNavigationContext.Provider value={value}>
      {children}
    </SuperAdminP2PNavigationContext.Provider>
  );
}

/** Use Super Admin P2P context on /super-admin/p2p/*; otherwise fall back to default hook caller. */
export function useSuperAdminP2PNavigationOverride() {
  return useContext(SuperAdminP2PNavigationContext);
}

export default SuperAdminP2PNavigationContext;
